import { createSelector } from 'reselect'

const getCurrentPrivateLibrary = state => state.libraries.current

const getCurrentLibraryUID = createSelector(
	[getCurrentPrivateLibrary],
	currentPrivateLibrary => currentPrivateLibrary ? currentPrivateLibrary.libraryUID : ''
)

export default getCurrentLibraryUID
